<div style="background-image: url('assets/img/bg/pattern.jpg')">
<app-header-three></app-header-three>
<div class="page-404-wrapper">
    <div class="page-404-text">
      <h1>Page Not Found</h1>
      <p>Sorry, the page you're looking for does not exist</p>
      <a routerLink='/' class="btn-custom">Go Back Home</a>
    </div>

    <div class="banner-bottom-img">
      <img src="assets/img/veg/2.png" alt="veg">
      <img src="assets/img/prods/3.png" alt="pizza">
      <img src="assets/img/veg/12.png" alt="veg">
    </div>
  </div>
<app-footer></app-footer>
</div>